import React, { useState, useEffect, useContext } from 'react';
import { LoadersContext } from '_models/context/app';
import { useForm } from 'react-hook-form';
import Grid from '@mui/material/Grid';

export const ApplyPackageHook = (props) => {
  const { cleanPortabilityAction, portability } = props;
  const { loaded, payload } = portability || {};
  const loadersContext = useContext(LoadersContext);
  const { setIsScreenLoading } = loadersContext || {};
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderButton, setLoaderButton] = useState(false);
  const [response, setResponse] = useState('');
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const {
    handleSubmit,
    control,
    register,
    setValue,
    watch,
    reset,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = () => {};

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  useEffect(() => {
    cleanPortabilityAction();
    return () => {
      cleanPortabilityAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsScreenLoading(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    const { message, detail, title } = payload || {};

    if (loaderButton && loaded) {
      setResponse(
        <Grid container className={'m-t-15 response-container'}>
          <Grid item size={{ xs: 12 }} className={'response-title'}>
            {title || ''}
          </Grid>
          <Grid item size={{ xs: 12 }} className={'response-text'}>
            {detail || message || ''}
          </Grid>
        </Grid>,
      );
      setLoaderButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portability]);

  useEffect(() => {
    if (isDialogOpen) {
      setIsLoading(false);
    }
  }, [isDialogOpen]);

  const myWrapper = (myComponents) => {
    return <form onSubmit={handleSubmit(onSubmit)}>{myComponents} </form>;
  };

  const handleAccept = () => {
    // Después de aplicar el paquete con éxito, abrir el diálogo de éxito
    setIsDialogOpen(false); // Cerrar el diálogo principal
    setSuccessDialogOpen(true);
  };

  return {
    myWrapper,
    successDialogOpen,
    handleSuccessDialogClose,

    isDialogOpen,
    setIsDialogOpen,
    handleAccept,
    control,
    register,
    setValue,
    watch,
    reset,
    getValues,
    errors,
    response,
  };
};
